interface StoresTranslations {
  pageTitle: string;
  subtitle: string;
}

export const storesTemplateTranslations: Record<string, StoresTranslations> = {
  en: {
    pageTitle: "LOCATIONS AND SERVICE",
    subtitle: "Find our nearest authorized dealers for sales and service"
  },
  de: {
    pageTitle: "STANDORTE UND SERVICE",
    subtitle: "Finden Sie unsere nächstgelegenen Vertragshändler für Verkauf und Service"
  }
}; 